import ReactDOM from 'react-dom';

/**
 * React 19 Compatibility Polyfill for findDOMNode
 * This is required for libraries like react-quill that still rely on findDOMNode.
 */
if (!ReactDOM.findDOMNode) {
    ReactDOM.findDOMNode = (instance) => {
        if (instance instanceof HTMLElement) return instance;
        if (instance?._reactInternalInstance) return instance._reactInternalInstance.node;
        // In React 19, most instances are either DOM nodes or have a direct reference
        return instance;
    };
}
